import React from 'react'
import { MasterPage } from 'app/interface/common/page'
import { Layout } from 'components/layout'

export const Master = ({ route, ...props }: MasterPage) => {
  return <Layout>{route ? <route.component {...props} /> : null}</Layout>
}
